export const boxStyle = {
  marginTop: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
